import { render, staticRenderFns } from "./show-service-data.vue?vue&type=template&id=10dbb472&scoped=true"
import script from "./show-service-data.vue?vue&type=script&lang=js"
export * from "./show-service-data.vue?vue&type=script&lang=js"
import style0 from "./show-service-data.vue?vue&type=style&index=0&id=10dbb472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dbb472",
  null
  
)

export default component.exports